var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 19.0333L6.46689 22.3666C6.22245 22.5222 5.96689 22.5888 5.70022 22.5666C5.43356 22.5444 5.20022 22.4555 5.00022 22.2999C4.80022 22.1444 4.64467 21.9499 4.53356 21.7166C4.42245 21.4833 4.40022 21.2222 4.46689 20.9333L5.93356 14.6333L1.03356 10.3999C0.811335 10.1999 0.672446 9.97216 0.61689 9.7166C0.561335 9.46105 0.578001 9.21105 0.66689 8.9666C0.755779 8.72216 0.889112 8.52216 1.06689 8.3666C1.24467 8.21105 1.48911 8.11105 1.80022 8.0666L8.26689 7.49993L10.7669 1.5666C10.878 1.29993 11.0502 1.09993 11.2836 0.966602C11.5169 0.833268 11.7558 0.766602 12.0002 0.766602C12.2447 0.766602 12.4836 0.833268 12.7169 0.966602C12.9502 1.09993 13.1224 1.29993 13.2336 1.5666L15.7336 7.49993L22.2002 8.0666C22.5113 8.11105 22.7558 8.21105 22.9336 8.3666C23.1113 8.52216 23.2447 8.72216 23.3336 8.9666C23.4224 9.21105 23.4391 9.46105 23.3836 9.7166C23.328 9.97216 23.1891 10.1999 22.9669 10.3999L18.0669 14.6333L19.5336 20.9333C19.6002 21.2222 19.578 21.4833 19.4669 21.7166C19.3558 21.9499 19.2002 22.1444 19.0002 22.2999C18.8002 22.4555 18.5669 22.5444 18.3002 22.5666C18.0336 22.5888 17.778 22.5222 17.5336 22.3666L12.0002 19.0333Z",
    fill: "#FFA534"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowStar);
export default __webpack_public_path__ + "static/media/yellow-star.e307af53684306eaad781c26a89417f6.svg";
export { ForwardRef as ReactComponent };